import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Button, Container, Row, Col, Alert,
    OverlayTrigger, Tooltip
} from 'react-bootstrap';
import SpinnerCard from './SpinnerCard';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faChevronCircleLeft,
    faChevronCircleRight,
    faCalendarAlt
} from '@fortawesome/free-solid-svg-icons'
import CalendarDay from './BookingCalendarDay';
import EditableHeader from './EditableHeader';
import {
    startOfWeekToYMD, endOfWeekToYMD,
    getWeekDays, getWeekNr, getMonthShortName,
    formatSlotFromTo, addDays
} from './CalendarUtil';
moment.locale('sv-SE');

function BookingTimeSelection(props) {

    const { licenseName } = useParams();
    const [license] = useState(licenseName);
    const [bookings, setBookings] = useState();
    let [currentDate, setCurrentDate] = useState(moment.utc().utcOffset(-1, true));
    let [selectedSlot, setSelectedSlot] = useState();

    useEffect(() => {
        if (props.shownControl === 'time') {
            const fetchData = async (lic) => {
                let from = startOfWeekToYMD(currentDate);
                let to = endOfWeekToYMD(currentDate);
                let query = `/api/${lic}/bookings?from=${from}&to=${to}`;
                const res = await fetch(query,
                    {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }
                    });
                const resJson = await res.json();
                setBookings(resJson);
            }
            fetchData(license);
        }
    }, [props.shownControl, license, currentDate]);

    function nextWeek() {
        setBookings(undefined);
        setCurrentDate(addDays(currentDate, 7));
    }

    function previousWeek() {
        setBookings(undefined);
        setCurrentDate(addDays(currentDate, -7));
    }

    function slotSelected(slot) {
        setSelectedSlot(slot);
        props.onSelect(slot);
    }

    function onEdit() {
        props.onEdit();
    }

    function getDays() {
        let days = getWeekDays(currentDate);
        const elements = days.map((d) => (
            <Col key={d}>
                <CalendarDay
                    customerData={props.customerData}
                    category={props.category}
                    onSelect={slotSelected}
                    bookings={bookings}
                    date={d}
                />
                <br />
            </Col>
        ));
        return (
            <Row noGutters={true} className="justify-content-md-center">
                {elements}
            </Row>
        );
    }

    function isShown() {
        return props.shownControl === 'time';
    }

    function hasValue() {
        return selectedSlot !== undefined;
    }

    function isLoading() {
        return bookings === undefined;
    }

    function bookingIsSaved() {
        return props.bookingSaved;
    }

    function weekButton(isPrevious) {
        var data = {
            tooltip: isPrevious ? "Föregånde vecka" : "Nästa vecka",
            onClick: isPrevious ? previousWeek : nextWeek,
            icon: isPrevious ? faChevronCircleLeft : faChevronCircleRight
        }
        return (
            <OverlayTrigger placement="bottom" overlay={
                <Tooltip>
                    {data.tooltip}
                </Tooltip>
            }>
                <Button onClick={data.onClick} className="d-block mx-auto" variant="secondary">
                    <FontAwesomeIcon icon={data.icon} className="fa-2x" />
                </Button>
            </OverlayTrigger>
        );
    }

    function getBookings() {
        if (!isShown()) {
            if (!hasValue()) {
                return (
                    <Alert variant="section-header">
                        <FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: 10 }} />
                        Välj dag &amp; tid
                    </Alert>
                );
            } else {
                if (!bookingIsSaved()) {
                    return (
                        <EditableHeader icon={faCalendarAlt} onEdit={onEdit} selectedValue={formatSlotFromTo(selectedSlot)} header="Vald dag &amp; tid: " />
                    );
                } else {
                    return (
                        <Alert variant="saved-header">
                            <FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: 10 }} />
                            Vald dag &amp; tid: <b>{formatSlotFromTo(selectedSlot)}</b>
                        </Alert>
                    );
                }
            }
        }
        if (isLoading()) {
            return (
                <Row className="justify-content-center align-items-center row-eq-height">
                    <SpinnerCard />
                </Row>
            );
        } else {
            return (
                <Container>
                    <Alert variant="section-header">
                        <FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: 10 }} />
                        Välj dag &amp; tid
                    </Alert>
                    <Row className="justify-content-md-center border-bottom">
                        <Col xs={3}>
                            {weekButton(true)}
                        </Col>
                        <Col xs={6}>
                            <h4 className="text-center text-headertext" variant="secondary">vecka {getWeekNr(currentDate)}</h4>
                            <h5 className="text-center text-subtext" variant="success">{getMonthShortName(currentDate)}</h5>
                        </Col>
                        <Col xs={3}>
                            {weekButton(false)}
                        </Col>
                    </Row>
                    <br />
                    {getDays()}
                </Container>
            );
        }

    }

    return (
        getBookings()
    );

}

export default BookingTimeSelection;